"use client";

import careersPath from "@faire/web-api/routes/careers";
import belongingPath from "@faire/web-api/routes/careers/belonging-at-faire";
import jobOpeningsPath from "@faire/web-api/routes/careers/openings";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { observer } from "mobx-react";
import React from "react";

import { TopOfPageContentWrapper } from "@faire/retailer/components/App/TopOfPageContent/Wrapper";
import { HeaderCareersDesktop } from "@faire/retailer/components/Header/desktop/HeaderCareersDesktop";
import { HeaderCareersMobile } from "@faire/retailer/components/Header/mobile/HeaderCareersMobile";

interface IPath {
  label: string;
  path: string;
}

export interface IHeaderProps {
  pathList: IPath[];
}

const HeaderCareersBase: React.FC = () => {
  const { isTabletAndBelow } = useViewport();
  const pathList = usePathList();
  return (
    <TopOfPageContentWrapper>
      {isTabletAndBelow ? (
        <HeaderCareersMobile pathList={pathList} />
      ) : (
        <HeaderCareersDesktop />
      )}
    </TopOfPageContentWrapper>
  );
};

export const HeaderCareers = observer(HeaderCareersBase);

const usePathList = (): IPath[] => {
  const { strictLocalize } = useStrictLocalization();
  return [
    {
      path: careersPath(),
      label: strictLocalize({
        defaultMessage: "Life at Faire",
        description: {
          text: "The tab for choosing life at faire",
          img: "https://cdn.faire.com/fastly/55b1c8ed74c991b19c51463c5edd407751a784a4e28aa726b13ddb77b522cdee.png",
        },
      }),
    },
    {
      path: belongingPath(),
      label: strictLocalize({
        defaultMessage: "Belonging at Faire",
        description: {
          text: "The tab for belonging at Faire",
          img: "https://cdn.faire.com/fastly/55b1c8ed74c991b19c51463c5edd407751a784a4e28aa726b13ddb77b522cdee.png",
        },
      }),
    },
    {
      path: jobOpeningsPath(),
      label: strictLocalize({
        defaultMessage: "All Job Openings",
        description: {
          text: "The tab for All Job Openings",
          img: "https://cdn.faire.com/fastly/55b1c8ed74c991b19c51463c5edd407751a784a4e28aa726b13ddb77b522cdee.png",
        },
      }),
    },
  ];
};
